import React from "react";

class AppFieldContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
     
    };
  }

  propWeight(){ return this.props.weight || 1 }
  propChildren(){ return this.props.children }

  componentDidUpdate(prevProps) {
   
  }

  getCalculatedWeight(){
      return this.propWeight() * 12
  }

  render() {
    return <div className={"col-12 col-lg-" + this.getCalculatedWeight()}>
        {this.propChildren()}
    </div>;
  }
}

export default AppFieldContainer;
